module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/r5LTwu/tc-custom/9781398442351.jpg?1718046581523",
      "alt": "This image is the cover for the book Prove It All Night"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Prove It All Night\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Can there be anything more uplifting than a great rock concert? A concert where words like brilliant, fantastic, superb, amazing and incredible can never do it justice. They don’t even come close. If you are blessed to have seen that one special gig that actually changed your life, a gig that you wished had never come to an end, then maybe, just maybe, you’ve been in the presence of greatness. A night to remember that will never fade from your memory, however long you live. It’s as fresh today as it was all those years ago. It was a rock and roll epiphany.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen B. Charles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephen grew up beside the seaside in Lancashire, England, with his younger sister and three older brothers, where their parents ran a family guest house and he attended the local grammar school. When not working as an IT contractor in Central London, he enjoys playing the piano, the guitar and the drums, writing songs, playing Bridge, learning Italian, listening to music, travelling, gardening, bird watching and jogging. His ambition is to cruise around the world writing best-selling novels, inspired by the fascinating and amusing people he meets along the way.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0